


















































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
//@ts-ignore
import store from "../store";
// @ts-ignore
import Tools from "../../helpers/Tools";
import {ContentPack, CurrentGame} from "../../types";
import EventApi from "../api/EventsApi";
import GameCard from "./Widgets/GameCard.vue";

@Component({
    components: {GameCard},
    props: {}
})

export default class GameWelcome extends Vue {
    private catalogIsOpened: boolean = false;
    private currentGame: CurrentGame|null = null;
    private currentPack: ContentPack|null = null;

    /**
     * Все игры
     */
    private get activities(): Array<CurrentGame>
    {
        return store.getters.getActivitiesList;
    }

    private get isMini(): boolean
    {
        return store.getters.getIsMini;
    }

    /**
     * Избранные игры
     */
    private get featuredGames(): Array<CurrentGame>
    {
        return this.activities.reduce((games: Array<CurrentGame>, game: CurrentGame) => {
            Object.values(game.contentPacks).forEach((pack: ContentPack) => {
                if (pack.is_homepage_visible) {
                    games.push(game);
                }
            });
            return games;
        }, []);
    }

    /**
     * Кол-во игр
     */
    private get gamesAmount(): number
    {
        return this.activities.length;
    }

    /**
     * Открыть/закрыть каталог
     * @private
     */
    private toggleCatalog(): void
    {
        this.catalogIsOpened = !this.catalogIsOpened;
        if (this.catalogIsOpened) {
            EventApi.triggerEvent(EventApi.OPEN_CATALOG);
        }

    }

    /**
     * Открыть каталог с выбранным паком
     * @param game
     * @param pack
     * @private
     */
    private openFeaturedGame(game: CurrentGame, pack: ContentPack): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.currentGame = game;
        this.currentPack = pack;
        this.catalogIsOpened = true;
        EventApi.triggerEvent(EventApi.OPEN_CATALOG, {game: this.currentGame, pack: this.currentPack});
    }
}
